export class Comment {
    id: number
    text: string
    createdBy: number
    createdByName: string
    createdDate: Date
    modifiedDate: Date
}
